import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from "./store";
import BootstrapVue from 'bootstrap-vue'
import ApiService from './common/api.service'
import ErrorService from './common/error.service'

// import Vue2Editor from "vue2-editor";

// Vue.use(Vue2Editor);

// import 'bootstrap/dist/css/bootstrap.css'
// import 'bootstrap-vue/dist/bootstrap-vue.css'
// import 'sweetalert2/dist/sweetalert2.css'
// import 'styles/global.scss'

Vue.use(BootstrapVue);
Vue.use(require('vue-moment'));
Vue.config.productionTip = false;

Vue.config.devtools = true;

ApiService.init();
ErrorService.init();

new Vue({
	router,
	store,
	render: h => h(App)
}).$mount('#app')
